import { combineReducers } from "@reduxjs/toolkit";
import authSlice from "./authSlice";
import orgSlice from "./orgSlice";

const rootReducer = combineReducers({
  user: authSlice,
  org: orgSlice,
});

export default rootReducer;
